import {
  EMPLOYEES_LOADING,
  EMPLOYEES_LOADED,
  EMPLOYEES_ERROR,
  EMPLOYEES_RESET,
  SET_CURRENT_EMPLOYEE,
  CLEAR_CURRENT_EMPLOYEE,
  UPDATE_EMPLOYEE,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case EMPLOYEES_RESET:
      return {
        ...state,
        ...action.payload,
      };
    case EMPLOYEES_LOADING:
      return {
        ...state,
        employeesLoading: true,
        employeesLoaded: false,
        error: null,
      };
    case EMPLOYEES_LOADED:
      return {
        ...state,
        employees: action.payload.employees,
        savedCriteria: action.payload.savedCriteria,
        employeesLoading: false,
        employeesLoaded: true,
        changedEmployees: [],
      };
    case UPDATE_EMPLOYEE:
      return {
        ...state,
        employeesLoading: false,
        employeesLoaded: true,
        selectedEmployee: action.payload,
      };
    case EMPLOYEES_ERROR:
      return {
        ...state,
        error: action.payload,
        employeesLoading: false,
        employeesLoaded: false,
      };
    case SET_CURRENT_EMPLOYEE:
      localStorage.setItem("selectedEmployee", JSON.stringify(action.payload));
      return {
        ...state,
        selectedEmployee: action.payload,
        employeesLoading: false,
        employeesLoaded: true,
      };
    case CLEAR_CURRENT_EMPLOYEE:
      localStorage.removeItem("selectedEmployee");
      return { ...state, selectedEmployee: null };
    default:
      return state;
  }
};
